import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyBrandsList = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/brandslist" */
      '.'
    ),
);
